import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { GetAdminDefinitionsGuard } from 'app/core/store/admin/admin-definitions/admin-definitions.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { Observable } from 'rxjs';
import * as fromRoot from '../..';
import { ClientUserLoadAction, StartCreateClientUserAction, StartInviteClientUserAction } from './users.actions';
import { filter, first, map } from 'rxjs/operators';

/**
 * Guard to async load an order before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetClientUserGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.store.dispatch(new ClientUserLoadAction(route.paramMap.get('id')));
    return this.store.select('admin').pipe(
      filter((admin: any) => !admin.edit.loading),
      first(),
      map((admin: any) => admin.edit.loadSuccess)
    );
  }

  getDependencies(): any {
    return [GetAdminDefinitionsGuard];
  }

  getDependencyRouteData(): any {}
}

@Injectable({ providedIn: 'root' })
export class InviteClientUserGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.store.dispatch(new StartInviteClientUserAction());
    return true;
  }

  getDependencies(): any {
    return [GetAdminDefinitionsGuard];
  }

  getDependencyRouteData(): any {}
}

@Injectable({ providedIn: 'root' })
export class CreateClientUserGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.store.dispatch(new StartCreateClientUserAction());
    return true;
  }

  getDependencies(): any {
    return [GetAdminDefinitionsGuard, AuthorizationGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'createClientUser',
    };
  }
}
